<template>
  <!-- 账号设置 -->
  <div class="person">
    <div class="tit">账号设置</div>
    <div class="tixing">
      <i class="el-icon-info"></i>
      若该手机号已绑定小程序，更换将会解绑。
    </div>
    <div v-if="status == 0">
      <div class="info emial">
        <div>
          <div>手机号</div>
          <el-input readonly v-model="phone" placeholder="请输入手机号"></el-input>
        </div>
        <el-button @click="genghuan" class="huan">更换手机号</el-button>
      </div>
    </div>
    <!-- <div v-if="status == 1">
      <div class="info emial">
        <div>
          <div>验证手机号</div>
          <el-input readonly v-model="phone" placeholder="请输入内容"></el-input>
        </div>
        <el-button @click="getCode('BGSJHM')" class="huan yan">
          {{ second === totalSecond ? "发送验证码" : second + `秒后重新发送` }}
        </el-button>
      </div>
      <el-input v-model="code" placeholder="验证码"></el-input>
      <el-button :disabled="!(phone!=''&&code!='')" class="wan" @click="status = 2">验证</el-button>
    </div> -->
    <div v-if="status == 1">
      <div class="info emial">
        <div>
          <div>绑定新手机号</div>
          <el-input v-model="phoneNew" placeholder="请输入新手机号"></el-input>
        </div>
        <el-button @click="getCode('BGSJHM')" class="huan yan">
          {{ second === totalSecond ? "发送验证码" : second + `秒后重新发送` }}
        </el-button>
      </div>
      <el-input v-model="codeNew" placeholder="验证码"></el-input>
      <el-button @click="changePhone('change')" class="wan">完成</el-button>
    </div>
  </div>
</template>
    
<script>
import { smsSendCode,bindMobile } from "@/api/api";
export default {
  components: {},
  data() {
    return {
      // 旧手机号
      phone: JSON.parse(localStorage.getItem("userInfo")).mobile,
      code: "",
      //   新手机号
      phoneNew: "",
      codeNew: "",
      status: 0,
      headers: {
        token: localStorage.getItem("token"),
      },
      userInfo: JSON.parse(localStorage.getItem("userInfo")),
      // 验证码倒计时
      // countdown:60,
      totalSecond: 60, // 总秒数
      second: 60, // 倒计时的秒数
      timer: null, // 定时器 id
    };
  },
  methods: {
    genghuan(){
      this.$confirm('请确认是否要更换手机号。若该手机号已绑定小程序，更换将会解绑。', '提示', {confirmButtonText: '确定',cancelButtonText: '取消',type: 'warning'}).then(async() => {
        this.status = 1
      }).catch(() => {
          this.$message({
              type: 'info',
              message: '已取消'
          });          
			});
    },
    // 校验手机号
    validFn() {
      let dianhua = this.phone;
      if (this.status == 1) {
        dianhua = this.phoneNew;
      }
      if (!/^1[3-9]\d{9}$/.test(dianhua)) {
        this.$message({
          message: "请输入正确的手机号",
          type: "error",
        });
        return false;
      }
      return true;
    },
    // 获取验证码
    async getCode(e) {
      // 判断手机号验证是否通过
      if (!this.validFn()) {
        return;
      }
      // mobile 手机号
      // scene YZMDL-验证码登录、BDSJHM-绑定手机号、BGSJHM-变更手机号、ZHDLMM-找回密码
      try {
        // 当前目前没有定时器开着，且 totalSecond 和 second 一致 (秒数归位) 才可以倒计时
        if (!this.timer && this.second === this.totalSecond) {
          // 开启倒计时
          this.timer = setInterval(() => {
            this.second--;

            if (this.second <= 0) {
              clearInterval(this.timer);
              this.timer = null; // 重置定时器 id
              this.second = this.totalSecond; // 归位
            }
          }, 1000);

          let dianhua = this.phone;
          if (this.status == 1) {
            dianhua = this.phoneNew;
          }

          // 调用接口
          let parame = {
            mobile: dianhua,
            scene: e,
          };
          const resCode = await smsSendCode(parame);
          if (resCode.code == 1) {
            console.log(resCode, "获取成功");
          }
        } else {
          // this.$message.error('请输入正确的手机号');
          this.$message({
            message: "您已发送！",
            type: "warning",
          });
        }
      } catch (error) {
        console.log(error,"获取失败");
      }
    },
    // 更换手机号
    async changePhone(e){
        let dianhua = this.phone;
        let yanzhengma = this.code
            if (this.status == 1) {
                dianhua = this.phoneNew;
                yanzhengma = this.codeNew
            }
        try {
            let parame = {
                mobile: dianhua,
                code:yanzhengma,
                type: e,
            };
            const res = await bindMobile(parame,this.headers)
                if(res.code==1){
                    this.$message({
                        message: '成功',
                        type: 'success'
                    });
                    this.status = 0

                    let storedObject = localStorage.getItem('userInfo');
                    if (storedObject) { // 检查是否真的有值，避免错误
                        let obj = JSON.parse(storedObject);
                        obj.mobile = this.phoneNew;
                        localStorage.setItem('userInfo', JSON.stringify(obj)); // 重新存储对象
                    }
                }else{
                    this.$message({
                        message: res.msg,
                        type: 'error'
                    });
                }
        } catch (error) {
            console.log(error,'手机号更换失败',);
        }
    }
  },
  destroyed() {
    // 关闭验证码计时器
    clearInterval(this.timer);
  },
};
</script>
    
<style style lang="scss" scoped>
.person {
  padding: 32px;
  box-sizing: border-box;

  .tit {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 18px;
    color: #333333;
    font-style: normal;
    text-transform: none;
  }

  .tixing {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #999999;
    font-style: normal;
    text-transform: none;
    margin-top: 8px;
  }

  .info {
    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    color: #606260;
    font-style: normal;
    text-transform: none;

    display: flex;

    margin-top: 24px;

    span {
      color: #fe3300;
    }

    .huan {
      width: 110px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;

      font-family: PingFang SC, PingFang SC;
      font-weight: 500;
      font-size: 14px;
      color: #999999;
      font-style: normal;
      text-transform: none;

      border: 0;
    }

    .yan {
      color: #0073f5;
      background: #edf6ff;
      padding: 0;
    }
  }
  :deep(.el-input) {
    input {
      width: 280px;
      height: 40px;
      background: #f9f9f9;
      border-radius: 8px 8px 8px 8px;
      border: 0;
    }

    margin-right: 48px;
    margin-top: 12px;
  }

  .emial {
    align-items: flex-end;
    .el-input {
      margin-right: 12px;
    }
  }

  .wan,.wan:hover {
    width: 110px;
    height: 40px;
    border-radius: 8px 8px 8px 8px;

    font-family: PingFang SC, PingFang SC;
    font-weight: 500;
    font-size: 14px;
    font-style: normal;
    text-transform: none;

    border: 0;
    background: #0073f5;
    color: #fff;

    margin-top: 24px;
  }
}
</style>